<template>
  <generic-container :title="$t('report viewer') + ' | ' + rpt.name" icon="line chart">
    <div class="ui dividing header">{{ $t("report setup") }}</div>
    <div class="ui form">
      <div data-step="1" ref="input_step" v-html="rpt.setup.input_screen_html"></div>
      <div class="three fields" style="margin-top:10px">
        <div class="field">
          <label>Fecha inicial</label>
          <div class="ui calendar" ref="rangestart">
            <div class="ui input left icon">
              <i class="calendar icon"></i>
              <input type="text" placeholder="Fecha inicial" />
            </div>
          </div>
        </div>
        <div class="field">
          <label>Fecha final</label>
          <div class="ui calendar" ref="rangeend">
            <div class="ui input left icon">
              <i class="calendar icon"></i>
              <input type="text" placeholder="Fecha final" />
            </div>
          </div>
        </div>
        <div class="field">
          <label for>{{ $t("query") }}</label>
          <div class="ui blue icon fluid labeled button" @click="submit">
            <i class="check icon"></i>
            {{ $t("get data")}}
          </div>
        </div>
      </div>
    </div>
    <div class="ui dividing header">{{ $t("report result") }}</div>
    <div data-step="2" id="result_step" ref="result_step"></div>
  </generic-container>
</template>

<script>
import filters from "@/filters";
import { local_api, stringify } from "@/utils";
import { groupBy } from "lodash";
import GenericContainer from "@/components/GenericContainer";
import Chart from "chart.js";
import Vue from "vue";

export default {
  name: "NgineDashboardReportViewer",
  components: {
    "generic-container": GenericContainer
  },
  filters: filters,
  data() {
    return {
      rpt: { setup: {} },
      step: 1,
      resultVue: undefined,
      inputVue: undefined
    };
  },
  computed: {},
  methods: {
    submit: function() {
      let vm = this;
      // let _v = this;
      window.jQuery("#result_step").html(vm.rpt.setup.result_screen_html);
      local_api(vm, "post", "/ngine_dashboard/report/do-execute", {
        i: vm.rpt.uuid,
        d: vm.inputVue.$data
      })
        // eslint-disable-next-line no-unused-vars
        .then(result => {
          let resultMixin = {};
          try {
            let mixin1 = undefined;
            // vm.setup.result_screen_html = s.setup.result_screen_html;
            if (vm.rpt && vm.rpt.setup) eval(vm.rpt.setup.result_screen_js);
            if (mixin1 != undefined) {
              resultMixin = mixin1;
            }
          } catch (err) {
            vm.$alertify.error(err);
          }
          return { resultMixin, result };
        })
        .then(r => {
          // eslint-disable-next-line no-unused-vars
          vm.resultVue = new Vue({
            mixins: [r.resultMixin],
            data: function() {
              return { result: r.result };
            },
            filters: filters,
            methods: {
              groupBy: groupBy,
              Chart: Chart,
              dynamicColors: function() {
                var r = Math.floor(Math.random() * 255);
                var g = Math.floor(Math.random() * 255);
                var b = Math.floor(Math.random() * 255);
                return "rgb(" + r + "," + g + "," + b + ")";
              }
            },
            el: "#result_step"
          });
        })
        .catch(err => {
          vm.$alertify.error(stringify(err));
        });
    }
  },
  created() {
    let vm = this;
    if (this.$route.query.i) {
      local_api(vm, "post", "/ngine_dashboard/report/do-get", {
        i: vm.$route.query.i
      })
        .then(s => {
          vm.rpt = s;

          setTimeout(() => {
            let inputMixin = {};
            try {
              let mixin = undefined;
              if (s && s.setup) eval(s.setup.input_screen_js);
              if (mixin) inputMixin = mixin;
              mixin = undefined;
            } catch (err) {
              vm.$alertify.error(err);
            }
            // eslint-disable-next-line no-unused-vars
            vm.inputVue = new Vue({
              mixins: [inputMixin],
              data: function() {
                return {
                  start_date: "",
                  end_date: ""
                };
              },
              filters: filters,
              el: vm.$refs.input_step,
              methods: {},
              mounted() {
                let _v = this;
                window.jQuery(vm.$refs.rangestart).calendar({
                  type: "datetime",
                  endCalendar: window.jQuery(vm.$refs.rangeend),
                  onChange: function(value) {
                    _v.start_date = value;
                  }
                });
                window.jQuery(vm.$refs.rangeend).calendar({
                  type: "datetime",
                  startCalendar: window.jQuery(vm.$refs.rangestart),
                  onChange: function(value) {
                    _v.end_date = value;
                  }
                });
              }
            });
          }, 200);
        })
        .catch(err => {
          vm.$alertify.error(stringify(err));
        });
    }
  },
  mounted() {
    if (!this.$route.query.i)
      this.$router.push({ name: "NgineDashboardIndex" });
  },
  watch: {}
};
</script>
